import { axiosBaseRequest, mapPollingData } from 'api/helpers';
import { pollingUrl } from 'api/endpoints';

import { getVerifyId } from 'utils/cookie';

export const pushPollingRequest = () => axiosBaseRequest({
  url: pollingUrl,
  params: { verify_id: getVerifyId() },
}).then(mapPollingData);
